angular.module('gym.components').directive('noPaymentSystem', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/contacts/wallet/no_payment_system.html.slim')
  };
});
